import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import CustomMultiselect from '@/components/ui/CustomMultiselect';
import { BaseOptionType } from '@/components/ui/CustomMultiselect/types';
import { useApplicationContext } from '@/context/v1/Application/context';
import { useGetErgonomicToolList } from '@/hooks/useGetErgonomicToolList';
import { FormItemWrapper } from '@/components/Settings/DataExtraction/styles';

const { useFormInstance, useWatch } = Form;

export function ToolFormItem(): JSX.Element {
	const form = useFormInstance();
	const { organization, company } = useApplicationContext();

	const selected: string[] = useWatch('ergonomic_tool_id', form) || [];

	const { isLoading, data } = useGetErgonomicToolList({
		organization_id: organization?.id,
		company_id: company?.id
	});

	return (
		<FormItemWrapper name="ergonomic_tool_id" label={I18n.get('Tool')} labelCol={{ span: 24 }}>
			<CustomMultiselect
				value={selected}
				options={data as BaseOptionType[]}
				loading={isLoading}
				placeholder={I18n.get('Tool')}
				onChange={(vals) => form.setFieldsValue({ ergonomic_tool_id: vals })}
			/>
		</FormItemWrapper>
	);
}
